import { z } from 'zod';
import { jSpotAutocompleteSchema, jUserAutocompleteSchema } from './autocomplete';
import { jFileLittleSchema } from './file';
import { jArticleViewSchema } from './article';
import { jUserLittleSchema } from './user';

export const extraBotConfigSchema = jArticleViewSchema.extend({
    avatar: z.optional(jFileLittleSchema),
    context: z.string(),
    description: z.string(),
    disclaimer: z.string(),
    enabled: z.boolean(),
    groups: z.optional(z.array(jSpotAutocompleteSchema)),
    moderators: z.optional(z.array(jUserAutocompleteSchema)),
    prompt: z.string(),
    title: z.string(),
    trigger: z.enum(['mentionOnly', 'matchComment']),
    matchThreshold: z.optional(z.number()),
    bot: z.optional(jUserLittleSchema),
    webhookMethod: z.optional(z.string()),
    webhookUrl: z.optional(z.string()),
    webhookKey: z.optional(z.string()),
    webhookAutomationOnly: z.optional(z.boolean()),
});

export type ExtraBotConfig = z.infer<typeof extraBotConfigSchema>;
